import { Store, toImmutable, Immutable } from 'nuclear-js';

import Actions from '../actions';
import DataUtils from 'data/utils';
import FormattingUtils from 'utils/formatting';

export default Store({
    getInitialState() {
        return toImmutable({
            schools: Immutable.List(),
            classes: Immutable.List(),
            instructors: Immutable.List(),
            students: Immutable.List(),
            selectedTermBid: null,
            selectedSchoolBid: null,
            selectedClassBid: null,
            selectedInstructorBid: null,
            selectedStudentBid: null,
        });
    },

    initialize() {
        this.on(Actions.roster.SELECT_ROSTER_TERM_BID, selectRosterTermBid);
        this.on(Actions.roster.SELECT_SCHOOL_BID, selectSchoolBid);
        this.on(Actions.roster.SELECT_CLASS_BID, selectClassBid);
        this.on(Actions.roster.SELECT_INSTRUCTOR_BID, selectInstructorBid);
        this.on(Actions.roster.SELECT_STUDENT_BID, selectStudentBid);
        this.on(Actions.roster.STORE_SCHOOLS, storeSchools);
        this.on(Actions.roster.STORE_CLASSES, storeClasses);
        this.on(Actions.roster.STORE_INSTRUCTORS, storeInstructors);
        this.on(Actions.roster.STORE_STUDENTS, storeStudents);
        this.on(Actions.roster.CLEAR_ROSTER_DATA, (state) => this.getInitialState());
        this.on(Actions.runtime.ADVANCE_TO_ADJACENT_STUDENT, advanceToAdjacentStudent);
        this.on(Actions.runtime.CLEAR_STATE, (state) => this.getInitialState());
    },
});

function advanceToAdjacentStudent(state) {
    const adjacentStudent = DataUtils.findAdjacentStudent();
    return adjacentStudent && adjacentStudent.get('studentBid', null)
        ? selectStudentBid(state, adjacentStudent.get('studentBid'))
        : state;
}

function storeSchools(state, schools) {
    return state.set('schools', toImmutable(schools));
}

function storeClasses(state, classes) {
    return state.set('classes', toImmutable(classes));
}

function storeInstructors(state, instructors) {
    return state.set('instructors', toImmutable(instructors));
}

export function storeStudents(state, students) {
    const studentsWithFullName = students.map((student) => {
        student.fullName = FormattingUtils.formatStudentName(student);
        return student;
    });

    const sortedStudents = toImmutable(studentsWithFullName).sortBy((s) =>
        s.get('fullName') !== null ? s.get('fullName').toLowerCase() : null
    );
    return state.set('students', sortedStudents);
}

function selectStudentBid(state, studentBid) {
    return state.set('selectedStudentBid', studentBid);
}

export function selectClassBid(state, classBid) {
    return state.withMutations((s) => {
        s.set('selectedClassBid', classBid);
        s.set('selectedStudentBid', null);
        s.set('students', Immutable.List());
    });
}

export function selectInstructorBid(state, instructorBid) {
    return state.withMutations((s) => {
        s.set('selectedInstructorBid', instructorBid);
        s.set('selectedClassBid', null);
        s.set('selectedStudentBid', null);
        s.set('classes', Immutable.List());
        s.set('students', Immutable.List());
    });
}

export function selectSchoolBid(state, schoolBid) {
    return state.withMutations((s) => {
        s.set('selectedSchoolBid', schoolBid);
        s.set('selectedInstructorBid', null);
        s.set('selectedClassBid', null);
        s.set('selectedStudentBid', null);
        s.set('instructors', Immutable.List());
        s.set('classes', Immutable.List());
        s.set('students', Immutable.List());
    });
}

export function selectRosterTermBid(state, termBid) {
    return state.withMutations((s) => {
        s.set('selectedTermBid', termBid);
        s.set('selectedSchoolBid', null);
        s.set('selectedInstructorBid', null);
        s.set('selectedClassBid', null);
        s.set('selectedStudentBid', null);
        s.set('schools', Immutable.List());
        s.set('instructors', Immutable.List());
        s.set('classes', Immutable.List());
        s.set('students', Immutable.List());
    });
}
